import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'mcrit-gestio-manage-project-task-list',
  templateUrl: 'task-list.component.html',
  styleUrls: ['task-list.component.css', '../list-cards.css']
})

export class TaskListComponent implements OnInit {
  @Input('taskList') taskList: any;

  constructor() { }

  ngOnInit() { }

}
